export default "__VITE_ASSET__hvAFiIRd__"